import React from "react";
import InputField from "../../forms/input-field";

const StorePayeeInfoTab = ({ disabled = false }) => {
  return (
    <div className="w-full 2xl:w-[35%] lg:w-[60%] px-5 xl:px-10">
      <InputField
        isDisabled={true}
        type="text"
        name="payee_name_as_per_bank"
        placeholder="Auto-filled from account details"
        label="Payee Name as per Bank"
        labelWidth="11.5rem"
      />
      <InputField
        isDisabled={true}
        type="text"
        name="payee_bank_name"
        placeholder="Auto-filled from account details"
        label="Payee Bank Name"
        labelWidth="11.5rem"
      />
      <InputField
        isDisabled={true}
        type="text"
        name="payee_bank_account_no"
        placeholder="Auto-filled from account details"
        label="Payee Bank Account No."
        labelWidth="11.5rem"
      />
      <InputField
        isDisabled={true}
        type="text"
        name="isfc_code"
        placeholder="Auto-filled from account details"
        label="IFSC Code"
        labelWidth="11.5rem"
      />
      <InputField
        isDisabled={disabled}
        // isRequired={true}
        type="text"
        name="extra_payee"
        placeholder="Enter Extra Payee"
        label="Extra Payee"
        labelWidth="11.5rem"
      />
    </div>
  );
};

export default StorePayeeInfoTab;
